export const openAppEnv =
  process.env.VUE_APP_RUN_ENV === "pro" ? "" : process.env.VUE_APP_RUN_ENV;

const openApp = ({
  address,
  title = document.title || "南方plus客户端",
  id,
  shareType,
  isActivity,
}) => {
  const options = {
    id: id || 12,
    shareType: shareType || "share",
    title,
    isActivity: isActivity,
    address,
    needClipboard: true,
  };
  window.OpenApp(options, openAppEnv);
};

let resolveFn;
const p = new Promise((resolve) => {
  resolveFn = resolve;
});

export const waitForResult = () => p;
export const resolveResult = (data) => resolveFn(data);

export default openApp;
